import {NgModule} from "@angular/core";
import {StoreModule} from "@ngrx/store";
import {ContactReducer} from "./contact/contact.reducer";
import {ContactEntity} from "./contact/contact.entity";
import {ContactService} from "./contact/contact.service";
import {BrowserModule} from "@angular/platform-browser";
import {TemplateEntity} from "./template/template.entity";
import {TemplateService} from "./template/template.service";
import {TemplateReducer} from "./template/template.reducer";
import {AuditEntity} from "./audit/audit.entity";
import {AuditReducer} from "./audit/audit.reducer";
import {AuditService} from "./audit/audit.service";
import {LocationReducer} from "./location/location.reducer";
import {LocationEntity} from "./location/location.entity";
import {NoteEntity} from "./note/note.entity";
import {NoteReducer} from "./note/note.reducer";
import {RemarkEntity} from "./remark/remark.entity";
import {RemarkReducer} from "./remark/remark.reducer";
import {LocationService} from "./location/location.service";
import {NoteService} from "./note/note.service";
import {RemarkService} from "./remark/remark.service";
import {SettingEntity} from "./setting/setting.entity";
import {SettingReducer} from "./setting/setting.reducer";
import {SettingService} from "./setting/setting.service";
import {ProtocolEntity} from "./protocol/protocol.entity";
import {ProtocolReducer} from "./protocol/protocol.reducer";
import {ProtocolService} from "./protocol/protocol.service";

export interface CleverreportStoreState {
  contacts: Array<ContactEntity>,
  templates: Array<TemplateEntity>,
  audits: Array<AuditEntity>,
  locations: Array<LocationEntity>,
  notes: Array<NoteEntity>,
  remarks: Array<RemarkEntity>,
  setting: SettingEntity,
  protocols: Array<ProtocolEntity>
}

@NgModule({
  imports: [
    BrowserModule,
    StoreModule.forRoot({
      contacts: ContactReducer,
      templates: TemplateReducer,
      audits: AuditReducer,
      locations: LocationReducer,
      notes: NoteReducer,
      remarks: RemarkReducer,
      setting: SettingReducer,
      protocols: ProtocolReducer
    })
  ],
  providers: [
    ContactService,
    TemplateService,
    AuditService,
    LocationService,
    NoteService,
    RemarkService,
    SettingService,
    ProtocolService
  ]
})

export class CleverreportStoreModule{}



// WEBPACK FOOTER //
// ./src/store/cleverreport.store.module.ts